import { createContext, useContext } from 'react';
export const CanvasContext = createContext({
    openCanvas: () => { },
    closeCanvas: () => { },
    isCanvasOpen: false,
    doCanvasAction: () => { },
    setCanvasDispatch: () => { },
    setCanvasState: () => { },
    createAssetClickHandler: () => () => { },
});
CanvasContext.displayName = 'CanvasContext';
export const useCanvasContext = () => {
    return useContext(CanvasContext);
};
//# sourceMappingURL=useCanvasContext.js.map